import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-712ff833"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-slide" }
const _hoisted_2 = { class: "select-btn" }
const _hoisted_3 = ["onMousedown"]

import { computed, ref } from "vue";
import { storeToRefs } from "pinia";
import { useMainStore, useSlidesStore, useKeyboardStore } from "@/store";
import { fillDigit } from "@/utils/common";
import { ContextmenuItem } from "@/components/Contextmenu/types";
import useSlideHandler from "@/hooks/useSlideHandler";
import useScreening from "@/hooks/useScreening";
import useLoadSlides from "@/hooks/useLoadSlides";

import ThumbnailSlide from "@/views/components/ThumbnailSlide/index.vue";
import LayoutPool from "./LayoutPool.vue";
import Draggable from "vuedraggable";
import { Popover } from "ant-design-vue";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, locale } = useI18n();

const mainStore = useMainStore();
const slidesStore = useSlidesStore();
const keyboardStore = useKeyboardStore();
const {
  selectedSlidesIndex: _selectedSlidesIndex,
  thumbnailsFocus,
  redrawFlag,
  isPc,
  isTourist,
} = storeToRefs(mainStore);
const { slides, slideIndex } = storeToRefs(slidesStore);
const { ctrlKeyState, shiftKeyState } = storeToRefs(keyboardStore);

const { slidesLoadLimit } = useLoadSlides();

const selectedSlidesIndex = computed(() => [
  ..._selectedSlidesIndex.value,
  slideIndex.value,
]);

const presetLayoutPopoverVisible = ref(false);

const {
  copySlide,
  pasteSlide,
  createSlide,
  createSlideByTemplate,
  copyAndPasteSlide,
  deleteSlide,
  cutSlide,
  selectAllSlide,
  sortSlides,
} = useSlideHandler();

// 切换页面
const changeSlideIndex = (index: number) => {
  mainStore.setActiveElementIdList([]);

  if (slideIndex.value === index) return;
  slidesStore.updateSlideIndex(index);
};

// 打开模板选择模态框
const openLayoutsPopover = () => {
  presetLayoutPopoverVisible.value = true;
};

// 点击缩略图
const handleClickSlideThumbnail = (e: MouseEvent, index: number) => {
  if (slideIndex.value !== index) mainStore.setRedrawState(false);

  const isMultiSelected = selectedSlidesIndex.value.length > 1;

  if (
    isMultiSelected &&
    selectedSlidesIndex.value.includes(index) &&
    e.button !== 0
  )
    return;

  // 按住Ctrl键，点选幻灯片，再次点击已选中的页面则取消选中
  if (ctrlKeyState.value) {
    if (slideIndex.value === index) {
      if (!isMultiSelected) return;

      const newSelectedSlidesIndex = selectedSlidesIndex.value.filter(
        (item) => item !== index
      );
      mainStore.updateSelectedSlidesIndex(newSelectedSlidesIndex);
      changeSlideIndex(selectedSlidesIndex.value[0]);
    } else {
      if (selectedSlidesIndex.value.includes(index)) {
        const newSelectedSlidesIndex = selectedSlidesIndex.value.filter(
          (item) => item !== index
        );
        mainStore.updateSelectedSlidesIndex(newSelectedSlidesIndex);
      } else {
        const newSelectedSlidesIndex = [...selectedSlidesIndex.value, index];
        mainStore.updateSelectedSlidesIndex(newSelectedSlidesIndex);
        changeSlideIndex(index);
      }
    }
  }
  // 按住Shift键，选择范围内的全部幻灯片
  else if (shiftKeyState.value) {
    if (slideIndex.value === index && !isMultiSelected) return;

    let minIndex = Math.min(...selectedSlidesIndex.value);
    let maxIndex = index;

    if (index < minIndex) {
      maxIndex = Math.max(...selectedSlidesIndex.value);
      minIndex = index;
    }

    const newSelectedSlidesIndex = [];
    for (let i = minIndex; i <= maxIndex; i++) newSelectedSlidesIndex.push(i);
    mainStore.updateSelectedSlidesIndex(newSelectedSlidesIndex);
    changeSlideIndex(index);
  }
  // 正常切换页面
  else {
    mainStore.updateSelectedSlidesIndex([]);
    changeSlideIndex(index);
  }
};

// 设置缩略图工具栏聚焦状态（只有聚焦状态下，该部分的快捷键才能生效）
const setThumbnailsFocus = (focus: boolean) => {
  if (thumbnailsFocus.value === focus) return;
  mainStore.setThumbnailsFocus(focus);

  if (!focus) mainStore.updateSelectedSlidesIndex([]);
};

// 拖拽调整顺序后进行数据的同步
const handleDragEnd = (eventData: { newIndex: number; oldIndex: number }) => {
  const { newIndex, oldIndex } = eventData;
  if (newIndex === undefined || oldIndex === undefined || newIndex === oldIndex)
    return;
  sortSlides(newIndex, oldIndex);
};

const { enterScreening, enterScreeningFromStart } = useScreening();

const contextmenusThumbnails = (): ContextmenuItem[] => {
  return [
    {
      text: t(`editor.ctrlV`), // '粘贴',
      subText: "Ctrl + V",
      handler: pasteSlide,
    },
    {
      text: t(`editor.ctrlA`), // '全选',
      subText: "Ctrl + A",
      handler: selectAllSlide,
    },
    {
      text: t(`editor.enter`), // '新建页面',
      subText: "Enter",
      handler: createSlide,
    },
    {
      text: t(`editor.f5`), // '幻灯片放映',
      subText: "F5",
      handler: enterScreeningFromStart,
    },
  ];
};

const contextmenusThumbnailItem = (): ContextmenuItem[] => {
  return [
    {
      text: t(`editor.ctrlX`), // '剪切',
      subText: "Ctrl + X",
      handler: cutSlide,
    },
    {
      text: t(`editor.ctrlC`), // '复制',
      subText: "Ctrl + C",
      handler: copySlide,
    },
    {
      text: t(`editor.ctrlV`), // '粘贴',
      subText: "Ctrl + V",
      handler: pasteSlide,
    },
    {
      text: t(`editor.ctrlA`), // '全选',
      subText: "Ctrl + A",
      handler: selectAllSlide,
    },
    { divider: true },
    {
      text: t(`editor.enter`), // '新建页面',
      subText: "Enter",
      handler: createSlide,
    },
    {
      text: t(`editor.ctrlD`), // '复制页面',
      subText: "Ctrl + D",
      handler: copyAndPasteSlide,
    },
    {
      text: t(`editor.delete`), // '删除页面',
      subText: "Delete",
      handler: () => deleteSlide(),
    },
    { divider: true },
    {
      text: t(`editor.shiftF5`), // '从当前放映',
      subText: "Shift + F5",
      handler: enterScreening,
    },
  ];
};

const redraw = (e: Event, index: number) => {
  e.preventDefault();
  if (redrawFlag.value) return;
  mainStore.setRedrawState(true);
  slidesStore.setRedrawData(slidesStore.slideList[index]);
};

return (_ctx: any,_cache: any) => {
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _component_IconDown = _resolveComponent("IconDown")!
  const _directive_contextmenu = _resolveDirective("contextmenu")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openLayoutsPopover()))
      }, [
        _createVNode(_component_IconPlus, { class: "icon" }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t(`editor.thumbnails.add`)), 1)
      ]),
      _createVNode(_unref(Popover), {
        trigger: "click",
        placement: "bottomLeft",
        visible: presetLayoutPopoverVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((presetLayoutPopoverVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(LayoutPool, {
            onSelect: _cache[1] || (_cache[1] = (slide) => {
          _unref(createSlideByTemplate)(slide);
          presetLayoutPopoverVisible.value = false;
        }
          )
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_IconDown, { class: "icon" })
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ], 512), [
      [_vShow, _unref(isPc) && !_unref(isTourist)]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['thumbnails', _unref(isPc) ? '' : 'mobileThumbnails']),
      id: "thumbnails",
      onMousedown: _cache[3] || (_cache[3] = () => setThumbnailsFocus(true))
    }, [
      _createVNode(_unref(Draggable), {
        class: _normalizeClass([
      _unref(isPc) ? 'thumbnail-list-PC' : 'thumbnail-list-mobile',
      'thumbnail-list',
    ]),
        id: "thumbnail-list",
        modelValue: _unref(slides),
        animation: 200,
        scroll: true,
        scrollSensitivity: 50,
        onEnd: handleDragEnd,
        delay: 200,
        itemKey: "id"
      }, {
        item: _withCtx(({ element, index }) => [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["thumbnail-item", {
          active: _unref(slideIndex) === index,
          selected: _unref(selectedSlidesIndex).includes(index),
        }]),
            onMousedown: ($event) => handleClickSlideThumbnail($event, index)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["label", { 'offset-left': index >= 99 }])
            }, _toDisplayString(_unref(fillDigit)(index + 1, 2)), 3),
            _createVNode(ThumbnailSlide, {
              class: "thumbnail",
              slide: element,
              size: 160,
              visible: index < _unref(slidesLoadLimit)
            }, null, 8, ["slide", "visible"])
          ], 42, _hoisted_3)), [
            [_directive_contextmenu, contextmenusThumbnailItem]
          ])
        ]),
        _: 1
      }, 8, ["class", "modelValue"])
    ], 34)), [
      [_directive_click_outside, () => setThumbnailsFocus(false)],
      [_directive_contextmenu, contextmenusThumbnails]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "my-btn page-number",
      style: {"color":"#333","background":"transparent"}
    }, _toDisplayString(_ctx.$t(`editor.thumbnails.slide`)) + " " + _toDisplayString(_unref(slideIndex) + 1) + " / " + _toDisplayString(_unref(slides).length), 513), [
      [_vShow, _unref(isPc)]
    ])
  ], 64))
}
}

})